// extracted by mini-css-extract-plugin
module.exports = {"iframe":"AntiSlaveryStatement_iframe__3TILW"};